/**
 * Normalizes a skills value from any shape (string[], object[], mixed) into a plain string array.
 * Handles GET responses where each skill may be a full object ({ name, displayName, ... })
 * or already a plain string.
 */
export const normalizeSkillNames = (skills: any): string[] => {
  if (!Array.isArray(skills)) return []

  const normalized = skills.flatMap((skill: any) => {
    if (typeof skill === 'string') return [skill]
    if (skill && typeof skill === 'object') {
      return [skill.name].filter((v): v is string => typeof v === 'string' && v.trim() !== '')
    }
    return []
  })

  return Array.from(new Set(normalized))
}

/**
 * Serializes a normalized skills array into the shape expected by POST/PUT endpoints:
 * [{ name: string }, ...]
 */
export const normalizeSkillsForApi = (skills: any): Array<{ name: string }> => {
  if (!Array.isArray(skills)) return []

  return skills
    .map((skill: any) => {
      if (typeof skill === 'string') return { name: skill }
      if (skill && typeof skill === 'object' && typeof skill.name === 'string')
        return { name: skill.name }
      return null
    })
    .filter((skill): skill is { name: string } => Boolean(skill?.name))
}
